import { useEffect, useState } from "react";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";
import Editor from 'react-simple-wysiwyg';

const LegalSettings = () => {
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    legal_notice: ""
  });

  const saveItem = () => {
    setLoading(true);
      axios
        .post(API_URL.SETTING_SAVE, formValue)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 1) {
            toast.success("Saved", {
                autoClose: 3000,
                
            });
          } else {
            toast.error(res.data.data, { autoClose: 3000 });
          }
        })
        .catch(() => {
          setLoading(false);
        });
  };

  const onEdit = () => {
    axios.post(API_URL.SETTING_SHOW, {}).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
            legal_notice: (res.data.data.legal_notice) ? res.data.data.legal_notice: ""
        });
      }
    });
  };

  const updateForm = (name, evt) => {
    console.log(name)
    console.log(evt.target.value)
    setFormValue({...formValue, [name]: evt.target.value});
  }

  useEffect(() => {
    onEdit();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>Legal Notice</h1>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <Editor value={formValue.legal_notice} onChange={(e) => updateForm('legal_notice', e)} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={saveItem}
                      disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LegalSettings;